import { render, staticRenderFns } from "./StarterPackDisableConfirmModal.vue?vue&type=template&id=37563ade&scoped=true"
import script from "./StarterPackDisableConfirmModal.vue?vue&type=script&lang=js"
export * from "./StarterPackDisableConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./StarterPackDisableConfirmModal.vue?vue&type=style&index=0&id=37563ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37563ade",
  null
  
)

export default component.exports